<script>
import { nextTick } from 'vue'

export default {
    name: "MessageBox",

    props: {
        text: {
            type: String,
            default: ''
        },
        type: {
            type: Number,
            default: -1
        },
        showButtons: {
            type: Boolean,
            default: true
        }
    },

    emits: ['form-closed'],

    async mounted() {
        await nextTick()
        document.getElementById('messageBox').focus()
    },
    
    methods: {
        // Helpers
        stopEnterPropagation() {
            // dummy to stop click propagation upwards in hierarchy            
        },

        async close() {
            this.$emit('form-closed', this.type)
        },
        handleFormKeyDown(event) {
            if (this.showButtons) {
                if (event.key === 'Enter') {
                    this.close()
                }
            }
        }
    }
}
</script>


<template>
    <div class="message-box">
        <div id="messageBox" @keydown="handleFormKeyDown" tabindex="-1">
            <div>{{ text }}</div>

            <div v-if="showButtons" class="message-box-buttons">
                <button class="button-small" @click="close">OK</button>
            </div>
        </div>
    </div>
</template>